var $ = require('jquery');
require('../../components/dataTable');

import {BalanceFilter} from "./BalanceFilter";


export const BalanceTable = {
    name: 'BalanceTable',
    components: {
        BalanceFilter
    },
    props: {
        free_tax: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            table: null
        }
    },
    mounted: function () {
        var _this = this
        this.$data.table = $('.table-cashflow').DataTable({
            ajax: {
                type: 'POST',
                url: '/ajax/get_cashflow',
                data: function (d) {
                    return $.extend({}, d, {
                        free_tax: _this.free_tax
                    });
                }
            },
            processing: true,
            serverSide: true,
            searching: true,
            paging: true,
            ordering: true,
            order: [[0, "desc"]],
            responsive: {
                details: {
                    type: 'column',
                    target: 0
                }
            },
            columns: [
                {
                    name: 'created_at', responsivePriority: 1, data: 'created_at', render: function (date) {
                        return date.slice(0, 10).replaceAll('-', '.');
                    }, targets: 4
                },
                {
                    name: 'title', responsivePriority: 2, data: 'title', render: function (value, pass, data) {

                        let index;
                        let values = value.split(' ')
                        for (index = 0; index < values.length; ++index) {
                            if (values[index].substring(0, 2) === "KJ") {
                                delete values[index];
                            }
                        }
                        let titleStr = values.join(' ');
                        let result = '<p class="typography typography__soft-underline identifier" style="text-align:left; margin: 0; padding:0">' + titleStr;

                        if (data.shipment) {
                            result += ' <a href="' + data.shipment.link + '">' + data.shipment.number + '</a>';
                        }

                        return result + '</p>';
                    }
                },
                {
                    name: 'value', responsivePriority: 3, data: 'value', render: function (value) {
                        value = (value + 0) / 100;
                        var isNegative = (value < 0);

                        var result = '<p style="text-align:right; margin: 0; padding:0">';
                        result += '<span class="';

                        result += (isNegative) ? '' : '';

                        if (!isNegative) {
                            result += 'text--green';
                        }

                        result += '">';
                        result += (isNegative) ? '-&nbsp;' : '+&nbsp;';
                        result += value.toFixed(2).toString().replace('-', '') + '&nbsp;zł';
                        result += '</span></p>';

                        return result;
                    }
                },
                {
                    name: 'balance', responsivePriority: 4, data: 'balance', render: function (value) {
                        var val = (((value + 0) / 100).toFixed(2)).toString() + '&nbsp;zł';
                        return '<p style="text-align:right; margin: 0; padding:0">' + val + '</p>';
                    }
                }
            ],
            language: {
                emptyTable: "Brak historii salda."
            }
        });

    },
    watch: {
        free_tax() {
            this.table.draw();
        }
    },
    methods: {},
    template: `
      <div>
          <BalanceFilter></BalanceFilter>
          <div>
              <table class="table table-cashflow table--full" style="width: 100%">
                <thead>
                <tr>
                  <th>Data</th>
                  <th>Tytuł</th>
                  <th>Kwota</th>
                  <th>Saldo&nbsp;po</th>
                </tr>
                </thead>
                <tbody>
                </tbody>
              </table>
          </div>
      </div>
    `
}